const WHITE = [255, 255, 255];
const BLACK = [0, 0, 0];

const RAMP = [
  ["50", WHITE, 0.92],
  ["100", WHITE, 0.84],
  ["200", WHITE, 0.66],
  ["300", WHITE, 0.45],
  ["400", WHITE, 0.22],
  ["500", WHITE, 0],
  ["600", BLACK, 0.12],
  ["700", BLACK, 0.26],
  ["800", BLACK, 0.42],
  ["900", BLACK, 0.6],
];

function parseHex(hex) {
  if (typeof hex !== "string") return null;
  const m = hex.trim().replace(/^#/, "");
  if (!/^[0-9a-fA-F]{6}$/.test(m)) return null;
  const rgb = [parseInt(m.slice(0, 2), 16), parseInt(m.slice(2, 4), 16), parseInt(m.slice(4, 6), 16)];
  if (m.toLowerCase() === "cccccc" || m.toLowerCase() === "666666") return null;
  return rgb;
}

function toHex(rgb) {
  return "#" + rgb.map((v) => Math.round(v).toString(16).padStart(2, "0")).join("");
}

function mix(rgb, target, amount) {
  return rgb.map((v, i) => v + (target[i] - v) * amount);
}

function luminance(rgb) {
  return (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255;
}

function toGround(rgb) {
  let out = mix(rgb, BLACK, 0.45);
  let guard = 0;
  while (luminance(out) > 0.18 && guard < 12) {
    out = mix(out, BLACK, 0.2);
    guard += 1;
  }
  return out;
}

export function brandThemeStyle(colors) {
  const primary = parseHex(colors && colors.primary);
  const secondary = parseHex(colors && colors.secondary);
  const style = {};

  if (primary) {
    RAMP.forEach(([stop, target, amount]) => {
      const value = toHex(mix(primary, target, amount));
      style["--primary-" + stop] = value;
      style["--color-primary-" + stop] = value;
    });
    style["--primary-DEFAULT"] = style["--primary-500"];
    style["--color-primary"] = style["--primary-500"];

    style["--color-resolve"] = toHex(primary);
    style["--color-resolve-light"] = toHex(mix(primary, WHITE, 0.22));
    style["--color-zen"] = toHex(toGround(primary));
  }

  if (secondary) {
    style["--color-pulse"] = toHex(secondary);
    style["--color-pulse-tint"] = toHex(mix(secondary, WHITE, 0.55));
  }

  return style;
}

export default brandThemeStyle;
